"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blockMaxWidth = exports.defaultBlockColorOrder = exports.primaryColorKey = void 0;
exports.primaryColorKey = 'primary';
exports.defaultBlockColorOrder = ['mood', 'background', 'mood', 'secondary']; // repeating
exports.blockMaxWidth = 3000;
//# sourceMappingURL=constants.js.map